import { render, staticRenderFns } from "./GlobalLoad.vue?vue&type=template&id=267fa8fb&scoped=true"
import script from "./GlobalLoad.vue?vue&type=script&lang=js"
export * from "./GlobalLoad.vue?vue&type=script&lang=js"
import style0 from "./GlobalLoad.vue?vue&type=style&index=0&id=267fa8fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267fa8fb",
  null
  
)

export default component.exports